"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVisibilitySelection = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelHelpTooltips_1 = require("../labels/help/LabelHelpTooltips");
const LabelCategories_1 = require("../labels/shared/LabelCategories");
function useVisibilitySelection(category, initialElevatedDefault, isLabelValue) {
    const [checkedIndex, setCheckedIndex] = react_1.default.useState(() => initialElevatedDefault === true ? 1 : 0);
    const [selectedValue, setSelectedValue] = react_1.default
        .useState(initialElevatedDefault ? initialElevatedDefault.toString() : 'false');
    const isEmptyOrCustomCategory = category.length < 1 || !(0, LabelCategories_1.isBuiltInLabelCategory)(category);
    if (isEmptyOrCustomCategory) {
        return { elevatedDefault: null, element: null };
    }
    const isSensitivity = category.toLowerCase() === 'sensitivity';
    const radioButtonList = [
        {
            label: catalog_messages_1.Messages.LabelVisibilityStandard(),
            testId: 'standard-option',
            value: 'false',
        },
        {
            label: catalog_messages_1.Messages.LabelVisibilityElevated(),
            testId: 'elevated-option',
            value: 'true',
        },
    ];
    const element = (react_1.default.createElement("div", { style: { paddingTop: 16 } },
        react_1.default.createElement(widgets_1.RadioButtonWithLabelGroupWidget, { buttonList: radioButtonList, checkedIndex: checkedIndex, handleChange: (value, newCheckedIndex) => {
                setSelectedValue(value);
                setCheckedIndex(newCheckedIndex);
            }, label: react_1.default.createElement(react_1.default.Fragment, null,
                catalog_messages_1.Messages.LabelVisibilityLevel(),
                react_1.default.createElement(LabelHelpTooltips_1.VisibilityTooltip, { isLabelValue: isLabelValue, isSensitivity: isSensitivity })), layout: widgets_1.RadioLayoutType.Veritical })));
    return { elevatedDefault: selectedValue === 'true', element };
}
exports.useVisibilitySelection = useVisibilitySelection;
//# sourceMappingURL=useVisibilitySelection.js.map